/* UNIFY USA runtime. Cart, drawer signalling, entrance animation.
   One file. No framework. Everything else on the site talks to the cart
   through window.UNIFY.cart rather than fetching /cart.js itself. */
(function () {
  'use strict';

  var listeners = [];
  var state = null;

  function emit(cart) {
    state = cart;
    listeners.forEach(function (fn) {
      try { fn(cart); } catch (e) { console.error('[unify] cart listener failed', e); }
    });
    document.dispatchEvent(new CustomEvent('unify:cart', { detail: cart }));
  }

  function request(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(
          function (j) { throw new Error(j.description || j.message || r.statusText); },
          function () { throw new Error(r.statusText); }
        );
      }
      return r.json();
    });
  }

  var cart = {
    get: function () { return state ? Promise.resolve(state) : cart.refresh(); },
    refresh: function () {
      return request('/cart.js').then(function (c) { emit(c); return c; });
    },
    add: function (id, qty) {
      return request('/cart/add.js', { items: [{ id: id, quantity: qty || 1 }] })
        .then(function () { return cart.refresh(); });
    },
    change: function (key, qty) {
      return request('/cart/change.js', { id: key, quantity: qty })
        .then(function (c) { emit(c); return c; });
    },
    clear: function () { return request('/cart/clear.js', {}).then(function (c) { emit(c); return c; }); },
    onChange: function (fn) { listeners.push(fn); if (state) fn(state); },
    open: function () { document.dispatchEvent(new CustomEvent('unify:cart:open')); },
    close: function () { document.dispatchEvent(new CustomEvent('unify:cart:close')); }
  };

  /* Entrance animation. One observer for the whole page. */
  function observeReveals() {
    var els = document.querySelectorAll('.reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  /* Measured ECOM disclosure motion. Native details remain usable without JS. */
  function initDisclosures() {
    document.querySelectorAll('.faq-item,.pdp__details details').forEach(function(detail) {
      var summary=detail.querySelector('summary'),answer=summary.nextElementSibling;
      var animation,fade,targetOpen=detail.open;
      summary.addEventListener('click',function(event) {
        if(matchMedia('(prefers-reduced-motion:reduce)').matches)return;
        event.preventDefault();
        var from=detail.getBoundingClientRect().height;
        var opacity=detail.open?Number(getComputedStyle(answer).opacity):0;
        if(animation)animation.cancel();if(fade)fade.cancel();
        targetOpen=!targetOpen;
        detail.style.height='';detail.style.overflow='hidden';
        detail.open=targetOpen;
        var to=detail.getBoundingClientRect().height;
        detail.open=true;
        summary.setAttribute('aria-expanded',String(targetOpen));
        summary.querySelector('svg').style.transform=targetOpen?'rotate(180deg)':'none';
        var timing={duration:300,easing:'cubic-bezier(.12,.23,.5,1)',fill:'both'};
        animation=detail.animate([{height:from+'px'},{height:to+'px'}],timing);
        fade=answer.animate([{opacity:opacity},{opacity:targetOpen?1:0}],timing);
        animation.onfinish=function(){detail.open=targetOpen;animation.cancel();fade.cancel();detail.style.overflow='';summary.removeAttribute('aria-expanded');summary.querySelector('svg').style.transform='';animation=null;fade=null;};
      });
      detail.addEventListener('toggle',function(){if(!animation)targetOpen=detail.open;});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initDisclosures);else initDisclosures();

  /* Header count bubble. Any element with [data-cart-count] stays in sync. */
  function bindCartCount() {
    var els = document.querySelectorAll('[data-cart-count]');
    if (!els.length) return;
    cart.onChange(function (c) {
      Array.prototype.forEach.call(els, function (el) {
        el.textContent = c.item_count;
        el.hidden = c.item_count === 0;
      });
    });
  }

  /* Background video. One implementation for every instance on the page. */
  function initBgVideos() {
    var vids = document.querySelectorAll('video[data-bgvideo]:not([data-bgv-init])');
    if (!vids.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var conn = navigator.connection || {};
    var thin = conn.saveData === true || /(^|-)2g$/.test(conn.effectiveType || '');

    Array.prototype.forEach.call(vids, function (v) {
      v.setAttribute('data-bgv-init', '1');
      v.dataset.offscreen = '1';

      if (reduce || thin) { v.removeAttribute('autoplay'); v.pause(); return; }

      /* Pick by CSS viewport width, NOT device pixels. A phone at DPR 3
         reports ~1125px across and would pull the 1080p file. */
      var w = window.innerWidth;
      var want = w < 750 ? 480 : (w < 1200 ? 720 : 1080);
      var srcs = [].slice.call(v.querySelectorAll('source'))
        .map(function (s) { return { el: s, h: parseInt(s.dataset.h, 10) || 0 }; })
        .sort(function (a, b) { return a.h - b.h; });
      var pick = null;
      for (var i = 0; i < srcs.length; i++) { if (srcs[i].h === want) { pick = srcs[i]; break; } }
      if (!pick) { for (var j = 0; j < srcs.length; j++) { if (srcs[j].h >= want) { pick = srcs[j]; break; } } }
      if (!pick) pick = srcs[srcs.length - 1];
      if (pick) {
        srcs.forEach(function (s) { if (s !== pick) s.el.remove(); });
      }

      /* Never resume a video that is scrolled out of view. The canplay and
         loadeddata handlers fire late and would otherwise restart a paused
         hero once the visitor had already scrolled past it. */
      function tryPlay() {
        if (v.dataset.offscreen === '1') return;
        if (pick && !v.getAttribute('src')) {
          v.src = pick.el.dataset.src;
          v.load();
        }
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
      /* Do NOT play on init. The observer below owns playback. Calling play()
         here marks every video as unpaused before we know if it is even on
         screen, which is why the newsletter video reported playing at the top
         of the page while having downloaded zero bytes. */
      v.addEventListener('canplay', tryPlay, { once: true });
      v.addEventListener('loadeddata', tryPlay, { once: true });
      v.addEventListener('pause', function () {
        if (v.dataset.offscreen !== '1') setTimeout(tryPlay, 60);
      });

      /* Never decode a video nobody is looking at. With the hero at the top
         and the newsletter at the bottom, only one ever runs. */
      if (!('IntersectionObserver' in window)) { v.dataset.offscreen = '0'; tryPlay(); }
      else {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { v.dataset.offscreen = '0'; tryPlay(); }
            else { v.dataset.offscreen = '1'; v.pause(); }
          });
        }, { threshold: 0.1 }).observe(v);
      }
    });
  }

  window.UNIFY = { cart: cart, observeReveals: observeReveals, initBgVideos: initBgVideos };

  document.addEventListener('DOMContentLoaded', function () {
    observeReveals();
    bindCartCount();
    initBgVideos();
    cart.refresh().catch(function (e) { console.warn('[unify] cart unavailable', e); });
  });

  /* Shopify re-renders sections in the theme editor. */
  document.addEventListener('shopify:section:load', function () {
    observeReveals();
    bindCartCount();
    initBgVideos();
  });
})();
